import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <div className="footer">
      Copyright © 2026 PIXELS2PIXELS. All rights reserved.
    </div>
  );
}
